module.exports = __webpack_public_path__ + "img/sv48.bc19a50a.svg";